export const entities = [
    {
        name: 'Contacts',
        fields: [
            {path: 'firstname'},
            {path: 'lastname'},
            {path: 'mail', encrypted: true, unique: true},
            {type: 'Function', link: 'MTM'},
            {path: 'phone', encrypted: true},
            {path: 'images', type: 'Image', link: {type: 'OTM', deleteType: 'cascade', onParent: true}},
            {path: 'comment'},
        ]
    },
    {
        name: 'Image',
        fields: [
            {path: 'name', notEmpty: true},
            'User',
            {path: 'date', notEmpty: true}
        ]
    }
]

export const administratorModule = {
    object: 'Contacts',
    name: 'administratorContactsModule',
    tKey: 'mTitle_experts',
    defaultSortBy: 'lastname',
    objectIdentifier: 'lastname',
    protectedExport: true,
    defaultSortDirection: 'ASC',
    category: {
        path: 'menuTitle_phoneBook',
        icon: 'notebook'
    },
    viewMap: {
        dt: [
            {path: 'lastname'},
            {path: 'firstname',},
            {path: 'functions', tKey: 'function(s)'},
            {path: 'phone'},
            {path: 'mail'}
        ],
        form: [
            {path: 'lastname', required: true},
            {path: 'firstname', required: true},
            {path: 'functions', tKey: 'function(s)', required: true},
            {path: 'phone', type: 'phoneNumber', required: true},
            {path: 'mail', required: true, emailAddress: true},
            {path: 'comment', tKey: 'presentation', type: 'richTextEditor'},
            {path: 'images', tKey: 'photo', placeholder: 'addPhoto', type: 'image', fieldPath: ['id', 'name', 'user.id', 'user.name', 'date'], singleImage: true}
        ]
    }
}

export const userModule = {
    object: 'Contacts',
    name: 'userContactsModule',
    tKey: 'mTitle_contacts',
    defaultSortBy: 'lastname',
    protectedExport: true,
    displayLog: false,
    defaultSortDirection: 'ASC',
    newable: false,
    removable: false,
    category: {
        path: 'menuTitle_myAssociation',
        icon: 'building'
    },
    viewMap: {
        dt: [
            {path: 'lastname'},
            {path: 'firstname'},
            {path: 'functions', tKey: 'function(s)'},
            {path: 'phone'},
            {path: 'mail'},
        ],
        form: [
            {tKey: 'photo', path: 'images', type: 'media', fieldPath: ['id', 'name', 'user.id', 'user.name', 'date'], containerStyle: {maxWidth: '700px'}, editable: false, hideLabel: true},
            {path: 'lastname', editable: false, disabled: true},
            {path: 'firstname', editable: false},
            {path: 'functions', tKey: 'function(s)', editable: false},
            {path: 'phone', type: 'phoneNumber', editable: false},
            {path: 'mail', editable: false},
            {path: 'comment', tKey: 'presentation', type: 'richTextEditor', readOnly: true},
        ]
    }
}
